import { render, staticRenderFns } from "./EditNameCustomizedGoalModal.vue?vue&type=template&id=66d88ba7&scoped=true&"
import script from "./EditNameCustomizedGoalModal.vue?vue&type=script&lang=ts&"
export * from "./EditNameCustomizedGoalModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditNameCustomizedGoalModal.vue?vue&type=style&index=0&id=66d88ba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d88ba7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VCol,VContainer,VDialog,VIcon,VImg,VRow,VTextField})
